import { combineReducers } from 'redux';
import dialogs from './dialogsReducer';
import selectors from './selectorsReducer';
import tables from './tablesReducer';

const uiElements = combineReducers({
  selectors,
  tables,
  dialogs,
});

export default uiElements;
